export const hyb_jarvis:string = '($0M3t!mES Y()U ';
